import { render } from "./ConfPortal.vue?vue&type=template&id=13e28330&scoped=true"
import script from "./ConfPortal.vue?vue&type=script&lang=js"
export * from "./ConfPortal.vue?vue&type=script&lang=js"

import "./ConfPortal.vue?vue&type=style&index=0&id=13e28330&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e28330"]])

export default __exports__